<section (mouseleave)="ttip.close()" class="container">
  <button
    (click)="onSwitchClick()"
    [disabled]="!searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount"
    #ttip="ngbTooltip"
    i18n-ngbTooltip
    [ngbTooltip]="
      !searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount
        ? 'Hotels are not available for selected location'
        : null
    "
    triggers="manual"
    (focus)="ttip.open()"
    (mouseenter)="ttip.open()"
    (blur)="ttip.close()"
    [attr.aria-describedby]="
      !searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount
        ? 'hotel-unavailable-msg'
        : null
    "
    i18n-aria-label
    [attr.aria-label]="
      'Switch to hotel search. Hotels from ' +
      (searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount
        ? (searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount
          | currency: searchService.searches[ServiceType.Hotel]?.cheapestPrice?.currencyCode)
        : 'not available')
    "
    appButton="small"
    class="alternative-button"
    id="button-switchtoHotel"
  >
    <i class="ico-bed" aria-hidden="true"></i>
    <span i18n="@@railHotelsFrom" aria-hidden="true">Hotels From:</span>
    @if (
      (searchService.searches[ServiceType.Hotel]?.isLoading?.value ||
        searchService.searches[ServiceType.Hotel]?.fetching) &&
      !searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount
    ) {
      <span role="status" aria-live="polite" aria-label="Loading hotel prices">
        <app-loading-spinner size="sm" />
        <span class="sr-only" i18n="@@railHotelsLoading">Loading hotel prices...</span>
      </span>
    } @else {
      <span role="status" aria-live="polite" aria-atomic="true">
        <span class="sr-only" i18n="@@railHotelsFrom">Hotels From:</span>&nbsp;
        {{
          searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount
            ? (searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount
              | currency: searchService.searches[ServiceType.Hotel]?.cheapestPrice?.currencyCode)
            : 'n/a'
        }}
      </span>
    }
  </button>
  <span id="hotel-unavailable-msg" class="sr-only" i18n="@@railHotelsUnavailableMessage"
    >Hotels are not available for selected location</span
  >
</section>
